import generateFileID from '@uppy/utils/lib/generateFileID';
import getFileType from '@uppy/utils/lib/getFileType';
import type {AnyUppyFile} from '../../types';
import {getUppyFileObjectFromFile} from './getUppyFileObjectFromFile';

/**
 * Generate an `Uppy` file id from a standard `File` object
 * @param file File
 * @returns `Uppy` file id
 */
export const getUppyFileIdFromFile = (file: File) => {
	const uppyFileObject = getUppyFileObjectFromFile(file) as AnyUppyFile;
	const fileType = getFileType(uppyFileObject);
	return generateFileID({
		...uppyFileObject,
		type: fileType,
	});
};
